module.exports = __webpack_public_path__ + "static/media/map-icon.e64f8dbf.svg";